module.exports = __webpack_public_path__ + "public/img/notData.aac490e2.png";